{
    "header" : "כל הפעולות מתפללים",
    "addOrder" : "הוסף הזמנה",
    "bigTable" : "טבלה כוללת",
    "balaceTable" : "טבלת יתרות",
    "addUser": "הוסף משתמש",
    "forms": "טפסים מיוחדים",
    "allUsers": "כל המתפללים"
}